import { isString, isValidNumber, ObjectAccessor } from '@dateam/ark';
import { parseObservationField } from './shared';
import { RecordValue, ValidationError } from './types';

/*
 ** Oïdium grappes
 ** - count: Comptage // /50 grappes
 **     0 <= Value <= 50
 **     Required
 ** - intensity: Intensité // %
 **     0 <= Value <= 100
 ** - comment: Commentaire
 */

type CurrentObservation = App.Observation39;
type CurrentApiObservation = App.Api.Observation39;

export const validate = (
    observation: CurrentObservation,
    _: App.InspectionPlotWithRecord
): Record<never, never> | Record<ObjectAccessor<Omit<CurrentObservation, 'previous'>>, ValidationError> => {
    const validation = {} as Record<ObjectAccessor<Omit<CurrentObservation, 'previous'>>, ValidationError>;

    const { ignored, count, intensity, comment } = observation;

    if (ignored === true) return validation;

    // The value must be defined
    if (count == null || !isValidNumber(count)) {
        validation.count = {
            field: 'count',
            type: 'error',
            code: 'required'
        };
    }
    else if (count < 0 || count > 50) {
        validation.count = {
            field: 'count',
            type: 'error',
            code: 'format'
        };
    }

    if (intensity != null) {
        if (!isValidNumber(intensity) || intensity < 0 || intensity > 100) {
            validation.intensity = {
                field: 'intensity',
                type: 'error',
                code: 'format'
            };
        }
    }

    if (comment != null && !isString(comment)) {
        validation.comment = {
            field: 'comment',
            type: 'error',
            code: 'format'
        };
    }

    return validation;
};

export const parse = (observation: CurrentApiObservation): CurrentObservation => {
    const {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        previous,
        count,
        intensity,
        comment
    } = observation;
    const parsedObs = {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        previous,
        isSyncing: false,
        isValid: true,
        hasChanged: false
    } as CurrentObservation;

    parsedObs.count = parseObservationField(count);
    parsedObs.intensity = parseObservationField(intensity);
    parsedObs.comment = parseObservationField(comment);

    return parsedObs;
};

export const map = (observation: CurrentObservation): CurrentApiObservation => {
    const {
        id,
        manuallyAdded,
        ignored,
        updatedOn,
        count,
        intensity,
        comment
    } = observation;
    const mappedObs = {
        id,
        manuallyAdded,
        ignored,
        updatedOn
    } as CurrentApiObservation;

    mappedObs.count = count !== undefined ? new RecordValue(count) : null;
    mappedObs.intensity = intensity !== undefined ? new RecordValue(intensity) : null;
    mappedObs.comment = comment !== undefined ? new RecordValue(comment) : null;

    return mappedObs;
};